import { shouldDynamicTagsTwoLines, shouldShowMoreDynamicTags } from '@/src/components/DynamicTag/utils';
import { GoldenProductCardTempID, GoldenProductGroceryCardTempID } from '@/src/pages/homepage/home_page_main/utils/constant';

/**
 * 商卡所在页面的筛排器埋点处理
 * @param filterPanelData
 * @returns
 */
const handleFilterParams = (filterPanelData) => {
  const { sortOptions, filterOptions } = filterPanelData?.json_data || {};
  let sort_code = '';
  let sort_name = '';
  if (sortOptions) {
    sortOptions?.sortOptionValues?.forEach((item) => {
      if (item.isSelected) {
        sort_code = item.sortCode;
        sort_name = item.sortName;
      }
    });
  }
  const filter_code_array: string[] = [];
  const filter_name_array: string[] = [];
  if (filterOptions) {
    filterOptions.forEach((filterOption) => {
      filterOption.filterOptionValues.forEach((item) => {
        if (item.isSelected) {
          filter_code_array.push(item.filterId);
          filter_name_array.push(item.filterDisplayName);
        }
      });
    });
  }
  const filter_code = filter_code_array.join(';');
  const filter_name = filter_name_array.join(';');
  const lxFilterParams = {
    sort_code,
    sort_name,
    filter_code,
    filter_name,
  };
  return lxFilterParams;
};

/**
   * 在数据源处计算动态标签行数&是否展示展开收起。
   * @param data
   * @returns
   */
const addDynamicTagProperty = (data: any) => {
  if (!data.module_body) {
    return data;
  }
  const headerComponentList = data.module_body.component_list || [];
  for (let index = 0; index < headerComponentList.length; index++) {
    const element = headerComponentList[index];
    if (element.component_id === GoldenProductCardTempID || element.component_id === GoldenProductGroceryCardTempID) {
      if (element.json_data.content && element.json_data.content.length > 0) {
        if (element.json_data.shouldShowMoreTags === undefined && element.json_data.isTwoLine === undefined) {
          // console.log('firstOfAll🐱',  element.json_data.shouldShowMoreTags, element.json_data.isTwoLine);
          const itemContent = element.json_data.content;
          const isTwoLine = shouldDynamicTagsTwoLines(element);
          const shouldShowMoreTags = shouldShowMoreDynamicTags(itemContent, element.layout_info, isTwoLine ? 2 : 1);
          element.json_data.shouldShowMoreTags = shouldShowMoreTags;
          element.json_data.isTwoLine = isTwoLine;
          // console.log('====== element =======🐱',  shopName, isTwoLine, shouldShowMoreTags);
        }
      }
    }
  }
  return data;
};

export {
  handleFilterParams, addDynamicTagProperty
};
